import React, { useEffect } from "react";
import { assetPath } from "../../utils/assetPath";

const AssetPreloader = () => {
  const assets = [
    "/AEPL_lOGO.svg",
    "/HomePage/heroBG.webp",
    "/HomePage/FivePrecisionInstruments/raptor1.webp",
    "/HomePage/FivePrecisionInstruments/raptor2.webp",
    "/HomePage/FivePrecisionInstruments/learnon1.webp",
    "/HomePage/FivePrecisionInstruments/learnon2.webp",
    "/HomePage/FivePrecisionInstruments/aurora1.webp",
    "/HomePage/FivePrecisionInstruments/aurora2.webp",
    "/HomePage/FivePrecisionInstruments/griffin1.webp",
    "/HomePage/FivePrecisionInstruments/griffin2.webp",
    "/HomePage/FivePrecisionInstruments/courseai1.webp",
    "/HomePage/FivePrecisionInstruments/courseai2.webp",
    "/PlatformImages/Industries/Aviation.webp",
    "/PlatformImages/Industries/Defence.webp",
    "/PlatformImages/Industries/Energy.webp",
    "/IndustriesImages/Aviation/HeroAviation.webp",
    "/IndustriesImages/Defence/DefenceHero.webp",
    "/IndustriesImages/Energy/EnergyHero.webp",
    "/PlatformImages/Raptor/RaptorBG.webp",
    "/PlatformImages/LearnOn/LearnOnHero.webp",
    "/PlatformImages/Aurora/AuroraHero.webp",
    "/PlatformImages/GRIFFIN/GriffinHero.webp",
    "/PlatformImages/CourseAI/CourseAIHero.webp",
    "/About/Idea/IdeaHero.webp",
    "/About/Quest/QuestHero.webp",
    "/About/Idea/Pic1.webp",
    "/About/Quest/Pic1.webp",
    "/clients/AirCanada.svg",
    "/clients/Etihad.svg",
    "/clients/Indigo.svg",
    "/clients/IndianNavy.svg",
    "/clients/Alstom.svg",
    "/clients/CAE.svg",
    "/clients/Delhimetro.svg",
    "/clients/PuneMetro.svg",
    "/clients/ONGC.svg",
    "/clients/Marigold.svg",
    "/clients/Sterling.svg",
  ];

  useEffect(() => {
    // Inject <link rel="preload"> into the document head for the highest browser priority
    assets.forEach((src) => {
      const resolvedSrc = assetPath(src);
      // Check if it already exists to prevent duplicate injection on re-renders
      if (!document.querySelector(`link[href="${resolvedSrc}"]`)) {
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = resolvedSrc;
        link.fetchPriority = "high";
        document.head.appendChild(link);
      }
    });
  }, []);

  return null;
};

export default AssetPreloader;
